var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfFile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2499 0H23.6232L34.9576 11.8141V34.7926C34.9576 37.6712 32.6287 40 29.7601 40H10.2499C7.37137 40 5.04254 37.6712 5.04254 34.7926V5.20738C5.04249 2.32883 7.37132 0 10.2499 0V0Z",
    fill: "#8EA4BE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.302,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6132 0V11.7241H34.9576L23.6132 0Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8296 29.8451V22.5387H13.938C14.7077 22.5387 15.3174 22.7486 15.7771 23.1784C16.2369 23.5982 16.4668 24.1679 16.4668 24.8776C16.4668 25.5872 16.2369 26.1569 15.7771 26.5767C15.3174 27.0065 14.7077 27.2164 13.938 27.2164H12.6987V29.8451H10.8296ZM12.6987 25.6272H13.7282C14.008 25.6272 14.2279 25.5672 14.3778 25.4273C14.5277 25.2974 14.6077 25.1175 14.6077 24.8776C14.6077 24.6377 14.5278 24.4578 14.3778 24.3279C14.2279 24.1879 14.008 24.128 13.7282 24.128H12.6987V25.6272ZM17.2364 29.8451V22.5387H19.8251C20.3348 22.5387 20.8146 22.6087 21.2644 22.7586C21.7141 22.9085 22.1239 23.1185 22.4837 23.4083C22.8436 23.6881 23.1334 24.068 23.3433 24.5477C23.5432 25.0275 23.6532 25.5772 23.6532 26.1969C23.6532 26.8066 23.5433 27.3563 23.3433 27.8361C23.1334 28.3158 22.8436 28.6956 22.4837 28.9755C22.1239 29.2653 21.7141 29.4752 21.2644 29.6252C20.8146 29.7751 20.3348 29.8451 19.8251 29.8451H17.2364ZM19.0655 28.2559H19.6052C19.895 28.2559 20.1649 28.2259 20.4148 28.1559C20.6546 28.086 20.8846 27.976 21.1045 27.8261C21.3143 27.6762 21.4843 27.4663 21.6042 27.1864C21.7241 26.9066 21.7841 26.5767 21.7841 26.1969C21.7841 25.8071 21.7241 25.4773 21.6042 25.1974C21.4843 24.9176 21.3143 24.7077 21.1045 24.5577C20.8846 24.4078 20.6547 24.2979 20.4148 24.2279C20.1649 24.158 19.895 24.1279 19.6052 24.1279H19.0655V28.2559ZM24.5927 29.8451V22.5387H29.7901V24.1279H26.4618V25.2973H29.1204V26.8766H26.4618V29.8451H24.5927Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfFile);
export default __webpack_public_path__ + "static/media/pdf-file.327ed9610a9418ecd7bccfa959746130.svg";
export { ForwardRef as ReactComponent };